import styled from "styled-components";


export const DeletePopupWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > p:nth-child(1) {
    color: #636363;
    text-align: left;
    color: #636363;
    // font-family: 'Open Sans';
font-family: inherit;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  & > p:nth-child(3) {
    //User name that will be displayed in the popup window
    span {
      color: #222;
    }
  }

  // Cancel and Delete button containers
  & > div:nth-child(3) {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    & > button {
      width: 200px;
      height: 45px;
      margin: 0 10px;
    }
    & > button:nth-child(1) {
      background-color: #fff;
      color: #222;
      width: max-content;
      margin-right: 30px;
      border: 1px #000;
    }
    & > button:nth-child(2) {
      background-color: #fff;
      color: #222;
      width: max-content;
      margin-right: 30px;
      border: 1px solid #000;
      border-radius: 100px;
      padding: 7px 21px;
    }
  }

  & .selectContainer {
    display: flex;
    justify-content: center;
    & > div {
      width: 40%;
    }
  }
`;
export const DivContainer = styled.div`
  display: flex;
  flex-direction:row;
  margin: 20px 10px 20px 0px;
`;
// export const RadioContainer = styled.div`
//  margin-left:10px;
//  margin-top: 5px;
//  padding-left: 10px;
//  text-align: center;
//  color: #636363;
// font-family: "Inter";
// font-size: 15px;
// font-style: normal;
// font-weight: 400;

//  & > input: nth-child(2) {
//    margin-left: 80px;
//  } 
// `;


export const RadioContainer = styled.div`
  padding-left: 20px;
  padding-top: 5px;
  display: flex;
  gap: 24px;

  color: #636363;

  // font-family: Open Sans;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;

  display: flex;
  align-items: center;
  & label {
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
  }

   & input[type='radio'] {
    appearance: none; /* Remove the default appearance of the radio button */
    width: 18px;      /* Adjust size of the radio button */
    height: 18px;
    border: 1px solid rgb(112 112 112); /* Border color */
    
    border-radius: 50%;        /* Round the edges */
    background-color: white;   /* Default background color */
    position: relative;        /* To position the checkmark */
    cursor: pointer;          /* Make it clickable */
    transition: all 0.3s ease; /* Smooth transition for hover/focus */
  }

& input[type='radio']::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: transparent;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: background-color 0.3s ease;
  }

  & input[type='radio']:checked {
    border-color: #2d8955;
  }

  & input[type='radio']:checked::after {
    background-color: #2d8955;
  }

  & input[type='radio']:hover {
    border-color: #2d8955;
  }
`;